import { Box, Typography, Grid } from "@mui/material";
import { REPORT_TYPES } from "../../../../data";

export default function ReportTypeSelector({ selected, onSelect }) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Select Report Type
      </Typography>

      <Grid container spacing={2}>
        {REPORT_TYPES.map((report) => (
          <Grid item xs={12} sm={6} md={4} key={report.id}>
            <Box
              onClick={() => onSelect(report.id)}
              sx={{
                p: 3,
                border: "2px solid",
                borderColor: selected === report.id ? "var(--peb-ocean)" : "var(--peb-stone)",
                borderRadius: 3,
                cursor: "pointer",
                transition: "all 0.2s ease",
                background: selected === report.id ? "rgba(47, 87, 143, 0.08)" : "#fff",
                "&:hover": {
                  borderColor: "var(--peb-ocean)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                },
              }}
            >
              <Typography sx={{ fontSize: 32, mb: 1 }}>{report.icon}</Typography>
              <Typography sx={{ fontWeight: 700, color: "var(--peb-slate)" }}>
                {report.title}
              </Typography>
              <Typography sx={{ fontSize: "0.85rem", color: "var(--peb-muted)", mt: 0.5 }}>
                {report.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
